<template>
 <div class="my-posts">
  <MobileNav :page_title="nav_title" />

  <!-- Right Section -->
  <div class="post-inner-section">
   <div class="expert-post">
    <div class="flex-space-between title-section" v-if="communityPosts.length">
     <div class="title">My Posts</div>
     <!-- <img src="../assets/images/filter.svg" alt="" /> -->
    </div>

    <ExpertCommunityPost :posts="communityPosts" />

    <!-- pagination -->
    <div style="text-align: center">
     <div class="show-more-tab" v-if="page_no < totalPages && !isCommunityPostsLoading" @click="loadMorePosts()">Load more</div>
    </div>

    <!-- Loader -->
    <div :class="{ 'infinite-loader-top-position': page_no == 1 }" v-if="isCommunityPostsLoading">
     <div class="text-center">
      <img src="../assets/images/company/loader.svg" style="height: 80px; width: 80px" />
     </div>
    </div>
    <!-- No data -->
    <div v-if="communityPostsLoaded && !isCommunityPostsLoading && !communityPosts.length">
     <NoDataFound></NoDataFound>
    </div>
   </div>
  </div>
 </div>
</template>

<script>
import MobileNav from '@/components/MobileNav.vue';
import { screenSize } from '../mixins/ScreenSize.js';
import { serverAddr, serverHostName } from '../networkConfig';
import ExpertCommunityPost from '@/components/ExpertCommunityPost.vue';
import NoDataFound from '@/components/NoDataFound.vue';
export default {
 name: 'ExpertBuzz',
 mixins: [screenSize],
 components: {
  MobileNav,
  ExpertCommunityPost,
  NoDataFound,
 },

 data() {
  return {
   nav_title: 'My Posts',
   isCommunityPostsLoading: false,
   communityPosts: [],
   page_no: 1,
   totalPages: null,
   communityPostsLoaded: false,
  };
 },

 created() {},

 mounted() {
  this.fetchAllData();
 },

 methods: {
  async loadMorePosts() {
   if (this.totalPages && this.page_no >= this.totalPages) return; // Prevent extra calls

   this.page_no += 1;
   const response = await this.getAllCommunityPosts(this.page_no);
   if (response && response.data && response.data.status) {
    this.communityPosts = [...this.communityPosts, ...response.data.data];
   }
  },

  async fetchAllData() {
   this.isCommunityPostsLoading = true;

   try {
    const [communityPosts] = await Promise.allSettled([
     this.getAllCommunityPosts(this.page_no),
     // ...other API calls if needed
    ]);

    if (communityPosts.status === 'fulfilled') {
     const data = communityPosts.value.data;
     // Only replace existing posts on first page
     if (this.page_no === 1) {
      this.communityPosts = data.data;
     } else {
      this.communityPosts = [...this.communityPosts, ...data.data];
     }

     this.totalPages = data.pagination.total_pages || null; // if your API sends total pages
    } else {
     console.error('Failed to fetch community posts:', communityPosts.reason);
    }

    this.communityPostsLoaded = true
   } catch (error) {
    console.error('Error in fetchAllData:', error);
   } finally {
    this.isCommunityPostsLoading = false;
   }
  },

  async getAllCommunityPosts(page = 1) {
   try {
    const response = await serverAddr.get(`/community/community-post?page_number=${page}&page_per_entries=5&posted_by=user`);
    return response;
   } catch (error) {
    console.error('Error fetching community posts:', error);
    return null;
   }
  },
 },

 beforeDestroy() {},

 computed: {
  userProfile() {
   return JSON.parse(localStorage.getItem('profile'));
  },
 },
};
</script>

<style lang="scss" scoped>
.my-posts {
 background-color: #f4f4f4;
 min-height: 100vh;
 overflow-x: hidden;
 margin-top: 60px;

 .post-inner-section {
  color: black;
  display: flex;
  justify-content: center;
  width: 100%;
  padding-top: 30px;
  .expert-post {
   .title-section {
    margin-bottom: 25px;
    .title {
     font-size: 15px;
     font-weight: 600;
    }
    img {
     width: 24px;
    }
   }
   width: 60%;
  }
 }

 @media (max-width: 1280px) {
  padding-bottom: 70px;
  .post-inner-section {
   width: 100%;
   margin-left: 0;
   padding-bottom: 70px;
  }
 }

 @media (max-width: 768px) {
  padding-bottom: 70px;

  .post-inner-section {
   width: 95%;
   margin: 0 auto;
   padding-bottom: 0;

   .expert-post {
    width: 100%;
   }
  }
 }
}
</style>

<style lang="scss">
.my-posts {
 @media (max-width: 768px) {
 }

 @media screen and (max-width: 600px) {
 }
}
</style>
